<template>
  <div class="content">
    <div class="block">
      <div class="block-header">
        <h3 class="block-title">
          User details
        </h3>
      </div>
      <div class="block-content block-content-full">
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">First Name:</label>
              <div class="col-sm-8 ">
                {{ user.first_name }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Last Name:</label>
              <div class="col-sm-8">
                {{ user.last_name }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header ">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Prefix:</label>
              <div class="col-sm-8">
                {{ user.prefix }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Gender:</label>
              <div class="col-sm-8">
                {{ user.gender }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Country:</label>
              <div class="col-sm-8">
                {{ user.country }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Time Zone:</label>
              <div class="col-sm-8">
                {{ user.time_zone }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header ">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Email:</label>
              <div class="col-sm-8">
                {{ user.email }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Secondary Email:</label>
              <div class="col-sm-8">
                {{ user.email2 }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Business Phone:</label>
              <div class="col-sm-8">
                {{ user.business_phone_code ? "+" + user.business_phone_code : "" }} {{ user.business_phone }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Mobile Phone:</label>
              <div class="col-sm-8">
                {{ user.mobile_phone_code ? "+" + user.mobile_phone_code : "" }} {{ user.mobile_phone }}
              </div>
            </div>
          </div>
        </div>
        <div class="row block-header ">
          <div class="col-md-12">
            <a :href="backUrl"><button
              type="button"
              class="btn btn-sm btn-primary"
            >
              Back
            </button></a>
          </div>
        </div>
      </div>
    </div>
    <!-- role -->
    <div
      v-if="user.roles"
      class="block"
    >
      <div class="block-header">
        <h3 class="block-title">
          Staff Security Settings
        </h3>
      </div>
      <div class="block-content block-content-full">
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Role:</label>
              <div
                v-if="user.roles.length > 0"
                class="col-sm-8 "
              >
                {{ user.roles[0].name }}
              </div>
              <div
                v-else
                class="col-sm-8 danger"
              >
                No roles assigned
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Parent Staff:</label>
              <div
                v-if="parent"
                class="col-sm-8"
              >
                <span v-if="parent.roles.length > 0">{{ parent.roles[0].name }}: </span>
                {{ parent.first_name }} {{ parent.last_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- staff details-->
    <div
      v-if="staff"
      class="block"
    >
      <div class="block-header">
        <h3 class="block-title">
          Staff profile
        </h3>
      </div>
      <div class="block-content block-content-full">
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Residential Address:</label>
              <div class="col-sm-8 ">
                {{ staff.residential_address }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Postal Code:</label>
              <div class="col-sm-8">
                {{ staff.postal_code }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header ">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Marital Status:</label>
              <div class="col-sm-8">
                {{ staff.marital_status }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Personal ID No.:</label>
              <div class="col-sm-8">
                {{ staff.personal_id_no }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Date of Birth:</label>
              <div class="col-sm-8">
                {{ dateConverted(staff.date_of_birth) }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Designation:</label>
              <div class="col-sm-8">
                {{ staff.designation }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Annual Vacation Days:</label>
              <div class="col-sm-8">
                {{ staff.annual_leave_days }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- next of kin -->
    <div
      v-if="staff"
      class="block"
    >
      <div class="block-header">
        <h3 class="block-title">
          Next Of Kin Details
        </h3>
      </div>
      <div class="block-content block-content-full">
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">First Name:</label>
              <div class="col-sm-8">
                {{ staff.kin_first_name }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Last Name:</label>
              <div class="col-sm-8">
                {{ staff.kin_last_name }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header ">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Relationship:</label>
              <div class="col-sm-8">
                {{ staff.kin_relationship }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Email Address:</label>
              <div class="col-sm-8">
                {{ staff.kin_email }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Country:</label>
              <div class="col-sm-8">
                {{ staff.kin_country }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Mobile Phone:</label>
              <div class="col-sm-8">
                {{ staff.kin_mobile_phone_code ? "+" + staff.kin_mobile_phone_code : "" }} {{ staff.kin_mobile_phone }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Residential Address:</label>
              <div class="col-sm-8">
                {{ staff.kin_residential_address }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Postal Code:</label>
              <div class="col-sm-8">
                {{ staff.kin_postal_code }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Personal ID No.:</label>
              <div class="col-sm-8">
                {{ staff.kin_personal_id_no }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Date of Birth:</label>
              <div class="col-sm-8">
                {{ dateConverted(staff.kin_date_of_birth) }}
              </div>
            </div>
          </div>
        </div>
        <div class="row block-header ">
          <div class="col-md-12">
            <a :href="backUrl"><button
              type="button"
              class="btn btn-sm btn-primary"
            >
              Back
            </button></a>
          </div>
        </div>
      </div>
    </div>

    <!-- bank settings -->
    <div
      v-if="staff"
      class="block"
    >
      <div class="block-header">
        <h3 class="block-title">
          Staff Payment Details
        </h3>
      </div>
      <div class="block-content block-content-full">
        <div class="row border-bottom block-header alternate">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Bank Name:</label>
              <div class="col-sm-8 ">
                {{ staff.bank_name }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Swift Code:</label>
              <div class="col-sm-8">
                {{ staff.swift_code }}
              </div>
            </div>
          </div>
        </div>
        <div class="row border-bottom block-header ">
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4">Account Number:</label>
              <div class="col-sm-8">
                {{ staff.account_number }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label class="col-sm-4" />
              <div class="col-sm-8" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    backUrl: {
      type: String,
      required: false,
      default: () => "/admin/staff/index",
    },
  },
  data() {
    return {
      user: {
        parent: null,
      },
    };
  },
  computed: {
    window() {
      return window;
    },
    staff() {
      return this.user.staff || null;
    },
    parent() {
      return this.user.parent || null;
    },
  },
  mounted() {
    this.getStaff();
  },
  methods: {
    async getStaff() {
      const url = this.url;
      const response = await axios.get(url);
      this.user = response.data.user;
      if (this.user.staff && this.user.staff.parent_id) {
        this.getParentStaff(this.user.staff.parent_id);
      }
    },
    async getParentStaff(id) {
      const url = this.url;
      const segements = url.split("/");
      segements[segements.length - 1] = "" + id;
      const newurl = segements.join("/");
      const response = await axios.get(newurl);
      this.$set(this.user, "parent", response.data.user);
      console.log(this.user.parent);
    },
    dateConverted(string) {
      return this.$moment(string).format("l");
    },
  },
};
</script>
